import { Registry } from '@react-registry'
import { Editor, Text, Transforms } from 'slate'
import { checkIfBreakIsNeeded, checkIfBreakIsNeededToRemove } from './utils'

export const withFragment = (editor) => {
  const { normalizeNode } = editor

  editor.normalizeNode = (nodeEntry) => {
    try {
      const [node, path] = nodeEntry

      // To run only once per normalization
      if (node['type'] !== 'doc') return normalizeNode(nodeEntry)

      // Add break true to text nodes
      const textEntriesToAddBreak = Array.from(
        Editor.nodes<Text>(editor, {
          at: [0],
          mode: 'all',
          match: (node, path) => checkIfBreakIsNeeded(editor, node, path)
        })
      )
      for (const [leaf, path] of textEntriesToAddBreak) {
        Transforms.setNodes(editor, { break: true } as any, { at: path })
      }

      // Remove unwanted break true from text nodes
      const textEntriesToRemoveBreak = Array.from(
        Editor.nodes<Text>(editor, {
          at: [0],
          mode: 'all',
          match: (node, path) => checkIfBreakIsNeededToRemove(editor, node, path)
        })
      )

      for (const [leaf, path] of textEntriesToRemoveBreak) {
        Transforms.unsetNodes(editor, 'break', { at: path })
      }

      normalizeNode(nodeEntry)
    } catch (error) {
      if (error instanceof Error) {
        error.message = 'Error while adding or removing break marks in fragment: ' + error.message
        console.error(error, JSON.stringify({ selection: editor.selection, children: editor.children }))
      }
    }
  }

  return editor
}

Registry.register(withFragment, {
  id: 'withFragment',
  registry: 'v2.plugin'
})
